<template>
  <md-select
    :value="value"
    md-dense
    :multiple="multiple"
    :disabled="disabled"
    :placeholder="defaultAny ? 'Any bag volume': placeholder"
    @md-selected="bagVolumeKeys => update(bagVolumeKeys)"
    @input="volumeKey => update(volumeKey)"
  >
    <md-option
      v-for="bagVolume of availableBagVolumes"
      :key="bagVolume.key"
      :value="bagVolume.key"
    >
      {{ bagVolume.label.en }}
    </md-option>
  </md-select>
</template>

<script>
import isArray from 'lodash/isArray';

import { infusionBagVolumes } from '~lib/common/config/medication';

export default {
  name: 'infusion-bag-volume-select',
  props: {
    value: {
      type: [Array, String],
      required: false,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    available: {
      type: Array,
      required: false,
      default: () => null,
    },
    defaultAny: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: ''
    },
  },
  computed: {
    availableBagVolumes() {
      if (!this.available) {
        return infusionBagVolumes;
      }
      const available = infusionBagVolumes.filter(bagVolume =>
        this.available.includes(bagVolume.key),
      );
      // If selected bag volume(s) aren't in the list of available, add
      // them in so the user can see the selected value
      const selected = isArray(this.value) ? this.value : this.value ? [ this.value ] : [];
      for (const bagVolumeKey of selected) {
        if (!this.available.includes(bagVolumeKey)) {
          const bagVolume = infusionBagVolumes.find(bv => bv.key === bagVolumeKey);
          available.push({
            ...bagVolume,
            label: {
              en: '*' + bagVolume.label.en
            }
          });
        }
      }
      return available;
    },
  },
  methods: {
    update(bagVolumeKeys) {
      this.$emit('input', bagVolumeKeys);
    },

  },
};
</script>

<style scoped></style>
